
/* Libraries */


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import Vue from 'vue/dist/vue'
window.Vue = require('vue');
// import Vue from "vue";
import VueRouter from 'vue-router';
import axios from "axios";

import Form from './core/Forms';
import Errors from './core/Errors.js';
import VueQrcodeReader from "vue-qrcode-reader";
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import css files
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

window.Vue = Vue;
window.axios = axios;


window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

window.Form = Form;
window.Errors = Errors;

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueQrcodeReader);
Vue.use(VueRouter);


import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
Vue.use(Vuetify)


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('qrcode', require('./qrcode.vue').default);
Vue.component('formulario', require('./vuetifydt.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const vueApp = new Vue({
    el: '#app',
    vuetify : new Vuetify(),

    components:{
           QrcodeStream,
           QrcodeDropZone,
           QrcodeCapture
       },
    data: {
            formdata: {
            },

    },
       methods: {
           changeVariable(value) {
               if (value === '') {
                   value = null;
               }
               this.$emit('input', value);
           },
       },
});
